class AdpComponentSectionController {
  constructor() {
    this.name = 'adpComponentSection';
  }
}

export default AdpComponentSectionController;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentSection/adpComponentSection.controller.js